module.exports = __webpack_public_path__ + "Deploy.35d78df753f0d28f800587e47dabe7d1.hashedasset.svg";